<template>
  <v-app-bar class="w-full z-20 border-b border-orange bg-white" height="100px" max-height="100" flat>
   <v-container>
      <GiddyUpWordmark class="gu__icon"/>
   </v-container>
  </v-app-bar>
</template>

<script>
import GiddyUpWordmark from "@/assets/GiddyUp_Wordmark.svg";

export default {
  components: {
    GiddyUpWordmark,
  },
  data: () => ({
    direction: "left",
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: true,
    left: false,
    transition: "slide-x-reverse-transition",
    model: 'tab-2',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  }),
};
</script>
